import React, { Component } from 'react';
import AsyncSelect from 'react-select/async';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { selectWarehouseAction } from '../actions/warehouse';
import { findWarehouses } from '../services/warehouse';

const styles = {
  container: {
    all: 'initial',
    userSelect: 'none',
    minWidth: 150,
  },
};

class WarehouseSelector extends Component {
  constructor(props) {
    super(props);

    const { warehouseName, warehouseId } = props;

    this.state = {
      currentWarehouse: {},
    };
    if (warehouseId !== -1) {
      this.state = {
        currentWarehouse: {
          name: warehouseName,
          id: warehouseId,
        },
      };
      this.onChange({ value: warehouseId, label: warehouseName });
    }
  }

  onChange = selectedOption => {
    const { selectWarehouse } = this.props;
    selectWarehouse(selectedOption.value, selectedOption.label);
  };

  loadOptions = async inputValue => {
    if (inputValue.length < 3) return [];
    const warehouses = await findWarehouses(inputValue);
    return warehouses.results.map(warehouse => ({
      label: warehouse.name,
      value: warehouse.id,
    }));
  };

  render() {
    const { currentWarehouse } = this.state;
    const { classes } = this.props;

    const asyncSelectProps = {
      onChange: this.onChange,
      loadOptions: this.loadOptions,
      placeholder: 'Select a warehouse',
    };

    if (currentWarehouse.name) {
      asyncSelectProps.defaultValue = { label: currentWarehouse.name, value: currentWarehouse.id };
    }
    return (
      <AsyncSelect
        onChange={asyncSelectProps.onChange}
        loadOptions={asyncSelectProps.loadOptions}
        placeholder={asyncSelectProps.placeholder}
        defaultValue={asyncSelectProps.defaultValue}
        className={classes.container}
      />
    );
  }
}

WarehouseSelector.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  selectWarehouse: PropTypes.func.isRequired,
  warehouseId: PropTypes.number.isRequired,
  warehouseName: PropTypes.string.isRequired,
};

const mapDispatchToProps = dispatch => ({
  selectWarehouse: (id, name) => {
    dispatch(selectWarehouseAction(id, name));
  },
});

const mapStateToProps = state => ({
  warehouseName: state.warehouse.warehouseName,
  warehouseId: state.warehouse.warehouseId,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(WarehouseSelector));
